import React, { ReactNode } from 'react'

import classnames from 'classnames'

import './CommonStyles.less'

interface CategoryItemPageHeaderProps {
  title: string
  question: string
  info?: string
  numberOfQuestions: number
  currentQuestion: number
  className?: string
  titleFontSize?: 20 | 30
}

const CategoryItemPageHeader: React.FC<CategoryItemPageHeaderProps> = (props) => {
  const classNames = classnames({
    'medium-font-size': props.titleFontSize === 20,
    'large-font-size': props.titleFontSize === 30,
  })
  const infoContent = () => {
    return props.info ? <label className="info">{props.info}</label> : null
  }
  return (
    <div className={`category_item__header ${props.className}`}>
      <h2 className={`title ${classNames}`}>{props.title}</h2>
      <h4 className="question_progress">
        Question ({props.currentQuestion}/{props.numberOfQuestions})
      </h4>
      <h5 dangerouslySetInnerHTML={{ __html: props.question }}></h5>
      {infoContent()}
    </div>
  )
}

export default React.memo(CategoryItemPageHeader)
